module.exports = __webpack_public_path__ + "static/media/orange-dollar.e8f0c42a.svg";